import {Component, Input, OnInit} from '@angular/core';
import {Offer} from '../../../../models/Offer';

@Component({
  selector: 'app-hover-preview',
  templateUrl: './hover-preview.component.html',
  styleUrls: ['./hover-preview.component.scss']
})
export class HoverPreviewComponent implements OnInit {
  @Input() hoveredOffer: Offer;
  @Input() mouseX: number;
  @Input() mouseY: number;
  
  constructor() {
  }
  
  ngOnInit() {
  }
  
  getPrice() {
    const price = this.hoveredOffer.price.replace(' ', '');
    let result = price;
    if (price.length >= 5) {
      const priceRounded = Math.round(Number(price) / 1000) * 1000;
      result = priceRounded / 1000 + 'k';
    }
    return result;
  }
}
